$(document).ready(function () {
  // Select all slides (both main and thumbnails)
  let slides = $(".desktop_gallery .product__media-item.slider__slide");
  let totalSlides = slides.length; // Correct total slide count

  // Hide navigation buttons if there are no images or only one image
  if (totalSlides <= 1) {
    $(".gallery-btn-left, .gallery-btn-right").hide();
  }

  console.log("Total Slides:" + totalSlides);

  /* desktop gallery control */

  $(".desktop_gallery .gallery-btn-right").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_gallery .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    console.log("desktop_mobile ... loading :" + totalSlides);

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let next = position + 1;

    console.log(next + " :" + totalSlides);
    // If we exceed the last slide, loop back to the first one (zero-based index)
    if (next >= totalSlides) {
      next = 0;
    }

    // Find the corresponding thumbnail and trigger click
    let nextThumbnail = $(".desktop_gallery .thumbnail-list__item")
      .eq(next)
      .find("button");

    if (nextThumbnail.length) {
      nextThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", next);
    }
  });

  $(".desktop_gallery .gallery-btn-left").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_gallery .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let prev = position - 1;

    // If we go before the first slide, loop back to the last one
    if (prev < 0) {
      prev = totalSlides - 1;
    }

    // Find the corresponding thumbnail and trigger click
    let prevThumbnail = $(" .desktop_gallery .thumbnail-list__item")
      .eq(prev)
      .find("button");

    if (prevThumbnail.length) {
      prevThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", prev);
    }
  });
});

//mobile gallery contorl

$(document).ready(function () {
  // Select all slides (both main and thumbnails)
  let slides = $(".desktop_mobile .product__media-item.slider__slide");
  let totalSlides = slides.length; // Correct total slide count

  console.log("desktop_mobile ... loading :" + totalSlides);

  // Hide navigation buttons if there are no images or only one image
  if (totalSlides <= 1) {
    $(".gallery-btn-left, .gallery-btn-right").hide();
  }

  console.log("Total Slides:", totalSlides);

  $(".desktop_mobile .gallery-btn-right").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_mobile .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let next = position + 1;

    console.log(next + " :" + totalSlides);
    // If we exceed the last slide, loop back to the first one (zero-based index)
    if (next >= totalSlides) {
      next = 0;
    }

    // Find the corresponding thumbnail and trigger click
    let nextThumbnail = $(".desktop_mobile .thumbnail-list__item")
      .eq(next)
      .find("button");

    if (nextThumbnail.length) {
      nextThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", next);
    }
  });

  $(".desktop_mobile .gallery-btn-left").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_mobile .product__media-item.slider__slide");
    let totalSlides = slides.length / 2; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let prev = position - 1;

    // If we go before the first slide, loop back to the last one
    if (prev < 0) {
      prev = totalSlides - 1;
    }

    // Find the corresponding thumbnail and trigger click
    let prevThumbnail = $(" .desktop_mobile .thumbnail-list__item")
      .eq(prev)
      .find("button");

    if (prevThumbnail.length) {
      prevThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", prev);
    }
  });
});

function updateTotalPrice() {
  // Get the base price from .price-item--regular (Detect currency from the text)
  let basePriceText = $(".price-item--regular").text().trim();
  let basePrice = parseFloat(basePriceText.replace(/[^0-9.]/g, "")) || 0;
  let currency = basePriceText.includes("USD") ? "USD" : "CAD"; // Detect currency

  // Get the extra charges from .bold_option_total span
  let extraPriceText = $(".bold_option_total span").text().trim();
  let extraPrice = parseFloat(extraPriceText.replace(/[^0-9.]/g, "")) || 0;

  if (extraPrice == "") {
    extraPrice = 0;
  }

  // Get the selected quantity
  let quantity = parseInt($("#qty-total").val()) || 1;

  // Calculate the total price
  let totalPrice = (basePrice + extraPrice) * quantity;

  // Update the total price in .total_amount with the detected currency
  $(".total_amount").text(`$${totalPrice.toFixed(2)} ${currency}`);

  if (totalPrice > 0) {
    // Update the total price in .total_amount with the detected currency
    $(".total_amount_header").text(`$${totalPrice.toFixed(2)} ${currency}`);
  }
}

// Function to handle the shape selection
function updateShapeSelection($shapeButton) {
  // Get the selected shape value
  var selectedShape = $shapeButton.data("shape");
  var selectedValue = $shapeButton.data("value");

  // Update the select dropdown value based on data-option_value_key
  $('select[name="properties[Shape]"]')
    .val(
      $(
        'select[name="properties[Shape]"] option[data-option_value_key="' +
          selectedValue +
          '"]'
      ).attr("value")
    )
    .trigger("change");

  // Update the display text for visual feedback
  $(".shape-text-display-shape").text($shapeButton.find(".shapeName").text());

  // Optional: Highlight the selected shape with an 'active' class
  $(".shape-button").removeClass("active"); // Remove active class from all shapes
  $shapeButton.addClass("active"); // Add active class to the selected shape

  updateSizes();
}

function updateSizes() {
  var $variantSelect = $("#variant");
  $variantSelect.empty();

  let shape = $("select[name='properties[Shape]']").val();
  let grade = $("select[name='properties[Grade]']").val();
  let $roundSizeSelect;
  //
  console.log("update size running " + shape + ":" + grade);

  if (shape == "Rectangle" && grade == "Gold") {
    $roundSizeSelect = $("select[name='properties[Gold Rectangle Sizes]']");
    $variantSelect.attr("properties", "Gold Rectangle Sizes");
  } else if (shape == "Rectangle" && grade == "Platinum") {
    $roundSizeSelect = $("select[name='properties[Platinum Rectangle Sizes]']");
    $variantSelect.attr("properties", "Platinum Rectangle Sizes");
  } else if (shape == "Rectangle" && grade == "Diamond") {
    $roundSizeSelect = $("select[name='properties[Diamond Rectangle Size]']");
    $variantSelect.attr("properties", "Diamond Rectangle Size");
  } else if (shape == "Oval" && grade == "Gold") {
    $roundSizeSelect = $("select[name='properties[Gold Oval Sizes]']");
    $variantSelect.attr("properties", "Gold Oval Sizes");
  } else if (shape == "Oval" && grade == "Platinum") {
    $roundSizeSelect = $("select[name='properties[Platinum Oval Sizes]']");
    $variantSelect.attr("properties", "Platinum Oval Sizes");
  } else if (shape == "Oval" && grade == "Diamond") {
    $roundSizeSelect = $("select[name='properties[Diamond Oval Size]']");
    $variantSelect.attr("properties", "Diamond Oval Size");
  } else if (shape == "Circle" && grade == "Gold") {
    $roundSizeSelect = $("select[name='properties[Gold Round Sizes]']");
    $variantSelect.attr("properties", "Gold Round Sizes");
  } else if (shape == "Circle" && grade == "Platinum") {
    $roundSizeSelect = $("select[name='properties[Platinum Round Size]']");
    $variantSelect.attr("properties", "Platinum Round Size");
  } else if (shape == "Circle" && grade == "Diamond") {
    $roundSizeSelect = $("select[name='properties[Diamond Round Size]']");
    $variantSelect.attr("properties", "Diamond Round Size");
  }

  $(
    'select[name="properties[Gold Rectangle Sizes]"], ' +
      'select[name="properties[Platinum Rectangle Sizes]"], ' +
      'select[name="properties[Diamond Rectangle Size]"], ' +
      'select[name="properties[Gold Round Sizes]"], ' +
      'select[name="properties[Platinum Round Size]"], ' +
      'select[name="properties[Diamond Round Size]"], ' +
      'select[name="properties[Platinum Oval Sizes]"], ' +
      'select[name="properties[Diamond Oval Size]"]'
  )
    .val("") // Reset values
    .each(function () {
      var selectElement = this;
      selectElement.dispatchEvent(new Event("change", { bubbles: true }));
      selectElement.dispatchEvent(new Event("input", { bubbles: true }));
    });

  // Remove all options from #variant select

  updateTotalPrice();

  if ($roundSizeSelect) {
    // Clone the options from Round Sizes and append them to #variant
    c = 0;
    $roundSizeSelect.find("option").each(function () {
      console.log("working");
      var value = $(this).attr("value");
      var text = $(this).text();
      var option = $("<option></option>")
        .attr("value", value)
        .text(text)
        .attr("key", c);
      $variantSelect.append(option);
      c++;
    });
  }
}

$(document).ready(function () {
  $(".sdt_card").click(function () {
    // Remove active class from all cards
    $(".sdt_card").removeClass("active");

    // Add active class to the clicked card
    $(this).addClass("active");

    // Get the selected value and option key
    var selectedValue = $(this).data("value");
    var optionKey = $(this).data("option-value-key");

    console.log("Selected Grade:", selectedValue);
    console.log("Option Key:", optionKey);

    // rest things
    $(".solar-color").hide();
    $(".oval-shape").show();
    $('input[name="properties[Color]"]').val("");
    $(".color-button").removeClass("selected");
    $(".dtext_target").empty();

    if (selectedValue === "Gold") {
      $(".solar-clear").show();
      $(".solar-blue").show();
    } else if (selectedValue === "Platinum") {
      $(".solar-navy").show();
    } else if (selectedValue === "Diamond") {
      $(".solar-blue").show();
    }

    // Update the Grade dropdown based on the selected card
    let $gradeSelect = $('select[name="properties[Grade]"]');
    let newValue = $gradeSelect
      .find('option[data-option_value_key="' + optionKey + '"]')
      .attr("value");

    if (newValue) {
      $gradeSelect.val(newValue).trigger("change");

      let gradeElement = $gradeSelect[0];
      if (gradeElement) {
        gradeElement.dispatchEvent(new Event("change", { bubbles: true }));
        gradeElement.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }

    // Call updateSizes to reflect changes
    updateSizes();
  });
});

$(document).ready(function () {
  //set view;
  $("#variant").empty();
  $(".rs-color").hide();
  $(".solar-color").hide();
  $(".real-form").hide();
  $(".size-guide-link-container").hide();
  // Initial update in case page loads with a quantity > 1
  updateTotalPrice();

  // Delegated event to handle click on any shape button
  $(".shape-container").on("click", ".shape-button", function (event) {
    // Prevent event bubbling to higher elements if needed
    event.stopPropagation();

    // Trigger the shape update event
    updateShapeSelection($(this));
  });

  $(".color-button").click(function () {
    var selectedColor = $(this).attr("value");
    // Update the input field
    $('input[name="properties[Color]"]').val(selectedColor).trigger("change");
    console.log("Selected Color:", selectedColor);
  });

  $("#variant").change(function () {
    // Get the properties attribute (e.g., "Oval Sizes")
    var properties = $(this).attr("properties");

    // Get the selected key and adjust it to match `data-option_value_key`
    var key = $(this).find(":selected").attr("key") - 1;

    console.log("Properties: " + properties);
    console.log("Key: " + key);

    // Find the matching properties select and update its value
    var $targetSelect = $('select[name="properties[' + properties + ']"]');
    var targetValue = $targetSelect
      .find('option[data-option_value_key="' + key + '"]')
      .attr("value");

    if (targetValue !== undefined) {
      $targetSelect.val(targetValue);

      // Dispatch change and input events to ensure proper updates
      let selectElement = $targetSelect[0]; // Get the raw DOM element
      selectElement.dispatchEvent(new Event("change", { bubbles: true }));
      selectElement.dispatchEvent(new Event("input", { bubbles: true }));
    }

    updateTotalPrice();
  });

  // cart send off //

  $(".addCart_fake").on("click", function () {
    // Clear any previous error messages
    $("#errorMessage").empty();

    let missingFields = [];

    // Check if a variant is selected
    if ($("#variant").val() === "") {
      missingFields.push("Variant");
    }

    // Check if a shape is selected
    if ($(".shape-button.active").length === 0) {
      missingFields.push("Shape");
    }

    // Check if a shape is selected
    if ($(".sdt_card.active").length === 0) {
      missingFields.push("Grade");
    }

    if ($(".solar-color.selected").length === 0) {
      missingFields.push("Color");
    }

    // If any fields are missing, show the error message and scroll to it
    if (missingFields.length > 0) {
      let errorMessage =
        "Please select the following before adding to cart: <br><ul>";
      missingFields.forEach((field) => {
        errorMessage += `<li>${field}</li>`;
      });
      errorMessage += "</ul>";

      $("#errorMessage").html(errorMessage);

      $("html, body").animate(
        {
          scrollTop: $("#errorMessage").offset().top - 20,
        },
        500
      );
    } else {
      console.log("All selections made. Adding to cart...");

      // Simulate clicking the real Add to Cart button

      var $quantityInput = $("#qty-total"); // The visible quantity field
      var $hiddenForm = $(".product-form form"); // Hidden SC Products form
      var $addToCartBtn = $(".addCart_fake"); // Fake Add to Cart button

      if (
        !$quantityInput.length ||
        !$hiddenForm.length ||
        !$addToCartBtn.length
      ) {
        console.error("One or more required elements not found.");
        return;
      }
      var quantityValue = $quantityInput.val();

      // Find or create the hidden quantity input inside the Shopify form
      var $hiddenQuantityInput = $hiddenForm.find("input[name='quantity']");
      if (!$hiddenQuantityInput.length) {
        $hiddenQuantityInput = $("<input>", {
          type: "",
          name: "quantity",
        }).appendTo($hiddenForm);
      }

      // Update the hidden quantity input value
      $hiddenQuantityInput.val(quantityValue);

      console.log("Submitting with quantity:", $hiddenQuantityInput.val()); // Debugging

      $(".product-form__submit.bold_hidden").trigger("click");
    }
  });

  $("#qty-total").on("input", function () {
    updateTotalPrice();
  });

  $("button.minus_qty").on("click", function () {
    console.log("Minus");
    let qtyInput = $("#qty-total");
    let currentValue = parseInt(qtyInput.attr("value")) || 1;

    // Decrease the value, but not below the min value
    if (currentValue > 1) {
      currentValue--; // Increment the value once
      qtyInput.val(currentValue);
      qtyInput.attr("value", currentValue);
      console.log("update price");
      updateTotalPrice();
    }
  });

  $("button.plus_qty").on("click", function () {
    let qtyInput = $("#qty-total");
    let currentValue = parseInt(qtyInput.attr("value")) || 1;
    currentValue++; // Increment the value once
    qtyInput.val(currentValue);
    qtyInput.attr("value", currentValue);
    console.log("update price");
    updateTotalPrice();
  });
});
